import { Tag } from "@braze/beacon-core"
import styled from "styled-components"
import { getColor } from "@braze/beacon-styling"





export const StatusTag = ({status} : {status:string}) => {
        
    return (
        <>
                <ColoredTag status={status}>
                    {status}
                </ColoredTag>
        </>
        
    )
}

const ColoredTag = styled(Tag)<{ status : string;}>`

    justify-content: center;
    font-size: 16px;
    min-width: fit-content;
    width: 50%;
    min-height: 2rem;
    background: ${({ status }) => {
        
        switch(status){
            case 'Submitted':
                return getColor("orange", 500);
            case 'Approved - Pending MarOps Review':
                return getColor('lightGreen', 500);
            case 'Launched':
                return getColor('lightBlue', 500);
            case 'Rejected':
                return getColor("red", 500);
            }
        }
    }}
    

`